const en = {

    campus : "Campus",
    faculty: "School / Faculty",
    department: "Department",
    academicYear:"Academic Year",
    semester:"Semester",
    course:"Select Course",

    header: {
        home: "Home",
        artworks: "Artworks",
        news: "News",
        about: "About Us",
        login: "Login",
        profile: "Profile",
        history: "History",
        submissions: "Submissions",
        dashboard: "Dashboard",
        logout: "Logout",
        cart: "Cart",
        contact: "Contact Us"
    },

    button: {
        setting:"Setting",
        create :"Create"
    },

    description : "Description",

    sidebar: {
        main: "Main",
        overview: "Overview",
        analytics: "Analytics",
        operations: "Operations",
        orders: "Orders",
        artworks: "Artworks",
        news: "News",
        submissions: "Submissions",
        dataCenter: "Data Center",
        users: "User Management",
        settings: "System Settings",
        returnToWebsite: "Back to Website",
        signOut: "Sign Out"
    }
}
export default en

